export default "__VITE_ASSET__6743c694__"